import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import tagsService from '@/services/setting/tagsService';
import companiesService from '@/services/companies/companiesService';

const toCompanyOptions = (rows) =>
    rows.map(comp => ({
        label: comp.name,
        value: comp.name,
        id: comp.id.toString(),
        original: comp,
    }));

const useCompaniesOptions = ({
    defaultPageSize = 20,
    type = null, // 👈 NEW
} = {}) => {
    const loadOptions = useCallback(
        async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
            try {
                const response = await companiesService.getAllCompanies({
                    page,
                    pageSize,
                    search,
                    type, // 👈 send to backend
                });

                const status =
                    typeof response?.status === 'boolean' ? response.status : true;
                if (!status) return { options: [], hasMore: false };

                let rows = getRows(response);

                //  Fallback (if backend doesn't filter yet)
                if (type) {
                    rows = rows.filter(tag => tag.type === type);
                }

                const options = toCompanyOptions(rows);
                console.log('opt', options)
                const totalRecords = getTotalRecords(response);
                const hasMore =
                    typeof totalRecords === 'number'
                        ? page * pageSize < totalRecords
                        : options.length === pageSize;

                return { options, hasMore };
            } catch (error) {
                console.error('Error', error);
                toast.error('Failed to fetch Tags.', {
                    description: 'Please try again.',
                });
                return { options: [], hasMore: false };
            }
        },
        [defaultPageSize, type]
    );

    return loadOptions;
};

export { useCompaniesOptions };
